// extracted by mini-css-extract-plugin
export default {"feature":"FeatureItems_feature__BOxAD","feature_title":"FeatureItems_feature_title__q7vQI","select":"FeatureItems_select__lLN2S"};